import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ onHireUsClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Contact', href: '#contact' },
    { name: 'Creative', href: '/creative-login' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/10 backdrop-blur-lg">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#home" className="text-xl font-bold drop-shadow-lg">
              <span className="text-white">lettherebe</span>
              <span className="inline-block">
                <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent glow-letter-slow" style={{animationDelay: '0s'}}>.</span>
                <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent glow-letter-slow" style={{animationDelay: '0.4s'}}>a</span>
                <span className="bg-gradient-to-r from-violet-400 to-pink-400 bg-clip-text text-transparent glow-letter-slow" style={{animationDelay: '0.8s'}}>i</span>
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-white hover:text-pink-300 transition-colors duration-200 font-medium drop-shadow-lg"
              >
                {link.name}
              </a>
            ))}
            <Button 
              onClick={onHireUsClick}
              className="bg-gradient-to-r from-violet-600 to-pink-600 text-white hover:shadow-lg hover:scale-105 transition-all duration-200"
            >
              Hire Us
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-pink-300 transition-colors drop-shadow-lg"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 bg-black/50 backdrop-blur-xl">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="block text-white hover:text-pink-300 transition-colors duration-200 font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <Button 
              onClick={() => {
                setIsMenuOpen(false);
                onHireUsClick && onHireUsClick();
              }}
              className="w-full bg-gradient-to-r from-violet-600 to-pink-600 text-white"
            >
              Hire Us
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;